import { apiRequest } from 'api/apiClient';

const updateRetailer = async ({ uid, is_blocked }) => {
  const response = await apiRequest('PATCH', `/v1/users/retailer-details/${uid}`, { is_blocked });
  return response;
};

const updateRetailerTrackingId = async ({ uid, retailer_tracking_id }) => {
  const response = await apiRequest('PATCH', `/v1/users/retailer-details/${uid}`, {
    retailer_tracking_id,
  });
  return response;
};

const updateRetailerPicture = async ({ vanity_url, picture_id }) => {
  const response = await apiRequest('PATCH', '/v1/retailer/me', {
    vanity_url,
    picture_id,
  });
  return response;
};

const updateRetailerConfig = async ({ vanity_url, retailer_tracking_id }) => {
  const response = await apiRequest('PATCH', '/v1/retailer/me', {
    vanity_url,
    retailer_tracking_id,
  });
  return response;
};

const deleteRetailer = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/users/retailer-details/${uid}`);
  return response;
};

const deleteRetailerProfile = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/retailer/${uid}`);
  return response;
};

const inviteRetailer = async ({ region_uid, email }) => {
  const response = await apiRequest('POST', '/v1/users/retailer-details/invite', {
    region_uid,
    email,
  });
  return response;
};

const inviteRetailers = async ({ region_uid, emails }) => {
  const response = await apiRequest('POST', '/v1/users/retailer-details/bulk-invite', {
    region_uid,
    emails,
  });
  return response;
};

const RETAILERS_MUTATIONS = {
  UPDATE_RETAILER: updateRetailer,
  UPDATE_RETAILER_TRACKING_ID: updateRetailerTrackingId,
  UPDATE_RETAILER_PICTURE: updateRetailerPicture,
  UPDATE_RETAILER_CONFIG: updateRetailerConfig,
  DELETE_RETAILER: deleteRetailer,
  DELETE_RETAILER_PROFILE: deleteRetailerProfile,
  INVITE_RETAILER: inviteRetailer,
  INVITE_RETAILERS: inviteRetailers,
};

export default RETAILERS_MUTATIONS;
